import { Node as ProseNode } from 'prosemirror-model';

export function childNodes(node: ProseNode): ProseNode[] {
  // @ts-ignore
  return node?.content?.content ?? [];
}
